// removed by extract-text-webpack-plugin
module.exports = {"messages":"_2IIi1Qs8SNbFvs4UwEXQp4","icon":"IIoyKBb8jIU2WbjwtOppc","text":"_18PSIL6RQh6HzYNClaOiw5","content":"_1ollcXRKJYuoRrWKVCdNk","title":"_3Xub6xCFzXeg-7VCOrcpek","subtitle":"_1XbFwLxNWt18OOYCSo99OP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailedInfo/MessageFromCompany/components/MessageBlock/MessageBlock.scss
// module id = 1685
// module chunks = 0